import { useFormikContext } from 'formik';
import { useEffect } from 'react';
import { useFetchSectorDepartments } from './use-fetch-sector-departments';
import { useFetchDepartmentEmployees } from './use-fetch-department-employees';

export const useFetchEmployeesFromSector = sector => {
  const { values, setFieldValue } = useFormikContext();

  if (!sector) {
    throw new Error('Você precisa informar o setor. Ex.: "licensas"');
  }

  if (!values['setores']) {
    throw new Error(
      'Você precisa incluir pelo menos um array vazio "setores" nos valores iniciais do formulário'
    );
  }

  const { departments, loading: loadingDepartments } = useFetchSectorDepartments(sector);
  const { employees, loading: loadingEmployees } = useFetchDepartmentEmployees(values['setores']);

  let loading = loadingEmployees || loadingDepartments;

  useEffect(() => {
    setFieldValue('usuarios', []);
    //eslint-disable-next-line
  }, [values['setores']]);

  return {
    loading,
    employees,
    departments,
  };
};
